import { type PaginationParams } from '@webapp/core/providers/Pagination/pagination.types'
import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { getMileageLockSettingUseCase } from '../business-logic/use-cases/GetMileageLockSetting'
import { expenseRepository } from '../data-access/repositories/ExpenseRepository'
import { type ApprovedExpenseItemListParams } from '../data-access/types/ApprovedExpenseItemListParams'
import { type ExpenseStatusEnum } from '../entities/enums/ExpenseStatusEnum'

const base = ['expense']

// Prefix of every listApprovedItems(params) key — account-code-correction
// Models invalidate all param variants through this. The sibling
// 'approved-items-count' badge key sits outside it by design.
export const EXPENSE_APPROVED_ITEMS_BASE_KEY = [...base, 'approved-items']

export const expenseQueryConfig = {
  // Plain array literal (not buildQueryKey): `status` can be undefined, and
  // buildQueryKey would truncate the key there and drop `params`.
  summaries: (status?: ExpenseStatusEnum, params?: PaginationParams) => ({
    queryKey: [...base, 'list', status, params],
    queryFn: () => expenseRepository.list(status, params),
  }),
  drafts: () => ({
    queryKey: buildQueryKey([...base, 'drafts']),
    queryFn: () => expenseRepository.getDrafts(),
  }),
  listApprovedItems: (params?: ApprovedExpenseItemListParams) => ({
    queryKey: buildQueryKey([...EXPENSE_APPROVED_ITEMS_BASE_KEY, params]),
    queryFn: () => expenseRepository.listApprovedItems(params),
  }),
  // Sibling segment outside the ['expense', 'approved-items'] list prefix by
  // design — corrections never refetch the badge
  approvedItemCount: () => ({
    queryKey: buildQueryKey([...base, 'approved-items-count']),
    queryFn: () => expenseRepository.getApprovedItemCount(),
  }),
  requestFormData: () => ({
    queryKey: buildQueryKey([...base, 'request-form-data']),
  }),
  mileageLockSetting: () => ({
    queryKey: buildQueryKey([...base, 'mileage-lock-setting']),
    queryFn: () => getMileageLockSettingUseCase.execute(),
  }),
}
